<template>
  <div class="publicStatic">
    <div>
      <el-row
        :gutter="12"
        type="flex"
        class="row-bg"
        justify="space-around"
        style="margin-bottom: 10px;"
      >
        <el-col :span="4">
          <el-input
            size="mini"
            placeholder="请输入关键字"
            v-model="form.name"
            style="margin-right: 6px;"
          ></el-input>
        </el-col>
        <el-col :span="8">
          <el-date-picker
            style="margin-right: 6px;"
            v-model="dateTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            :clearable="false"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="12">
          <div style="display: flex;align-items: center;">
            <el-button
              @click="searchData"
              size="mini"
              type="primary"
              icon="el-icon-search"
              >查询</el-button
            >
            <el-button
              @click="reset"
              size="mini"
              type="primary"
              icon="el-icon-search"
              >重置</el-button
            >
            <el-button @click="dialogUploadVisible = true" size="mini" type="primary"
              >上传</el-button
            >
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-table :data="tableData" style="width: 100%;height: 100%;">
          <el-table-column
            label="序号"
            type="index"
            width="100"
            align="center"
          />
          <el-table-column prop="name" label="会议名称" align="center" />
          <el-table-column prop="sessionsDate" label="时间" align="center" />
          <el-table-column prop="deptName" label="所属部门" align="center" />
          <el-table-column prop="userName" label="上传人" align="center" />
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="preview(scope.row)"
                >预览</el-button
              >
              <el-button size="mini" type="text" @click="viewDetail(scope.row)"
                >查看</el-button
              >
              <el-button size="mini" type="text" @click="download(scope.row)"
                >下载</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div style="display: flex;justify-content: center;margin-top: 10px;">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            @current-change="checkPage"
          >
          </el-pagination>
        </div>
      </el-row>

      <!-- 上传 -->
      <el-dialog title="上传" width="50%" :visible.sync="dialogUploadVisible">
        <el-row :gutter="1">
        <el-col :span="12"><el-form
          :model="formUpload"
          label-width="70px"
          ref="form"
          size="mini"
        >
          <div>
            <el-form-item
              label="会议名称"
              prop="askerName"
              style="font-weight: 600;"
            >
              <el-input
                v-model="formUpload.name"
                style="width: 200px;"
              ></el-input>
            </el-form-item>
            <el-form-item style="font-weight: 600;" label="新增事项">
            </el-form-item>
            <div v-for="i,index in formUpload.entryList" :key="i.key">
              <el-row style="display: flex;">
                <i
                  class="el-icon-circle-plus-outline"
                  style="margin-top: 8px;"
                  @click="addThings"
                ></i>
                <el-form-item label="添加事项" prop="tianjiashixiang">
                  <el-input
                    v-model="i.entryName"
                    style="width: 200px;"
                  ></el-input>
                </el-form-item>
              </el-row>
              <div style="margin-left: 50px;">
                <div v-for="item in i.personList" :key="item.key">
                  <i
                    class="el-icon-circle-plus-outline"
                    style="margin-top: 8px;position: absolute;left: 30px;"
                    @click.stop="addPerson(index)"
                  ></i>
                  <el-form-item label="跟进人员" prop="genjinrenyuan">
                    <!-- <el-input
                      v-model="i.userId"
                      style="width: 200px;"
                    ></el-input>
                    <el-button type="primary">查询</el-button> -->
                    <el-select v-model="item.userIds" multiple filterable placeholder="请选择跟进人员">
                      <el-option
                        v-for="u in userList"
                        :key="u.user_id"
                        :label="u.user_name"
                        :value="u.user_id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="选择时间" style="margin-left: 20px;">
                    <el-date-picker
                      style="width: 150px;"
                      v-model="item.date"
                      type="date"
                      size="mini"
                      placeholder="选择日期"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
        </el-form>
        </el-col>
        <!-- 文件上传  -->
        <el-col :span="12">
          <el-upload
          class="upload-demo"
          drag
          action="/api/pt/common/uploadFile"
          :headers="headers"
          :multiple="false"
          :on-error="onError"
          :before-upload="beforeUpload"
          :on-success="onSuccess"
          :limit="1"
          :on-exceed="handleExceed"
        >
          <el-icon class="el-icon-upload"><upload-filled /></el-icon>
          <div class="el-upload__text">
            点击或将文件拖拽到这里上传
          </div>
          <template #tip>
            <div class="el-upload__tip">
              支持扩展名：.doc .pdf .xlsx
            </div>
          </template>
        </el-upload>
        </el-col>
      </el-row>

        <div slot="footer" class="dialog-footer">
          <el-button
            :size="allWidth < 750 ? 'mini' : 'small'"
            @click="dialogFormVisible = false"
            >取 消</el-button
          >
          <el-button
            :size="allWidth < 750 ? 'mini' : 'small'"
            @click="add"
            type="primary"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <!-- 跟进事项 -->
      <el-dialog title="事项" width="50%" :visible.sync="itemDialogVisible" :before-close="beforeClose">
            <!-- 详情 -->
           <div v-if="entryBO == null">
          <el-table :data="sessionsDetail.entryBOList || []" style="width: 100%;height: 100%;">
            <el-table-column prop="entryName" label="跟进事项"  width="300px" />
            <el-table-column prop="fulfillmentDate" label="节点日期" align="center" width="200px"  />
            <el-table-column prop="userName" label="跟进人" align="center" width="70px" />
            <!--  0 未到期 1已完成 2已延期 3延期超时 -->
            <el-table-column prop="status" label="完成情况" align="center" width="80px">
              <template #default="scope">
                <el-tag v-if="scope.row.status == 0">{{"未到期"}}</el-tag>
                <el-tag v-else-if="scope.row.status == 1" type="success">{{ "已完成" }}</el-tag>
                <el-tag v-else-if="scope.row.status == 2" type="info">{{ "已延期" }}</el-tag>
                <el-tag v-else-if="scope.row.status == 3" type="danger">{{ "延期超时" }}</el-tag>
                <el-tag v-else type="warning">{{ "已超时" }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="modityEntryItem(scope.row)" v-show="isAdmin()"
                  >修改</el-button
                >
                <!--只要不是已完成都可以完成 -->
                <el-button size="mini" type="text" @click="updateSessionsEntryMethod(scope.row,'1')" v-show="scope.row.status !== '1'"
                  >完成</el-button
                >
                <!-- 未到期或者超时可以选择延期 -->
                <el-button size="mini" type="text" v-show="scope.row.status == '0' || scope.row.status == '5'" @click="delayTab(scope.row)">{{'延期'}}</el-button >
              </template>
             </el-table-column>
            </el-table>
           </div>
           <!-- 此处是延期和修改内容 -->
           <div v-else>
              <el-form :model="entryBO" label-width="auto" style="max-width: 600px" v-if="!entryBO.yq">
                <el-form-item label="会议节点">
                  <el-input v-model="entryBO.entryName" />
                </el-form-item>
                <el-form-item label="跟进人员">
                  <el-select v-model="entryBO.userId" filterable placeholder="请选择跟进人员">
                      <el-option
                        v-for="u in userList"
                        :key="u.user_id"
                        :label="u.user_name"
                        :value="u.user_id">
                      </el-option>
                    </el-select>  
                </el-form-item>
                <el-form-item label="状态">
                  <el-select v-model="entryBO.status" filterable placeholder="请选择状态">
                      <el-option
                        v-for="u in statusList"
                        :key="u.value"
                        :label="u.key"
                        :value="u.value">
                      </el-option>
                    </el-select>  
                </el-form-item>
                <el-form-item label="节点日期">
                  <el-date-picker
                    v-model="entryBO.fulfillmentDate"
                    type="date"
                    placeholder="请选择时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="updateSessionsEntryMethod(entryBO,null)">修改</el-button>
                  <el-button type="danger" @click="deleteEntry(entryBO)">删除</el-button>
                  <el-button @click="entryBO = null">返回</el-button>
                </el-form-item>
              </el-form>    
              <!-- 延期 -->
              <el-form :model="entryBO" label-width="auto" style="max-width: 600px" v-else>
                <el-form-item label="会议节点：">
                  <!-- <el-input v-model="entryBO.entryName"/> -->
                  {{entryBO.entryName}}
                </el-form-item>
                <el-form-item label="跟进人员：">
                  <!-- <el-input v-model="entryBO.userName" /> -->
                  {{entryBO.userName}}
                </el-form-item>
                <el-form-item label="节点日期：">
                  <!-- <el-input :value="entryBO._fulfillmentDate.split(' ')[0]" /> -->
                  {{entryBO._fulfillmentDate.split(' ')[0]}}
                </el-form-item>
                <el-form-item label="延期时间：">
                  <el-date-picker
                    v-model="entryBO.fulfillmentDate"
                    type="date"
                    placeholder="请选择时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="updateSessionsEntryMethod(entryBO,'2')">确认延期</el-button>
                  <el-button @click="entryBO = null">返回</el-button>
                </el-form-item>
              </el-form>    
           </div>
      </el-dialog>    
    </div>
  </div>
</template>

<script>
import { deleteSessionEntry, updateSessionsEntry,getSystemUserInfo, expUserList,sessionsMinutesList, addSessionsMinutes, sessionsMinutesById, getDownloadBlob, getUserList } from "@/api/dayqing";
import moment, { relativeTimeThreshold } from "moment";
import user from "../../store/modules/user";

export default {
  name: "ResultStatic",
  data() {
    return {
      headers:{
        "token": localStorage.getItem("usertoken")
      },
      //   未到期 1已完成 2已延期 3延期超时
      statusList:[
        {
          key: '未到期',
          value: '0'
        },
        {
          key: '已完成',
          value: '1'
        },
        {
          key: '已延期',
          value: '2'
        },
        {
          key: '延期超时',
          value: '3'
        },
        {
          key: '已超时',
          value: '4'
        }
      ],
      user: null,
      form: {
      },
      formUpload: {
        name:'',
        sessionsFile: null,
        entryList: [
          {
            personList:[
              {
              }
            ]
          }
        ]
      },
      userList:[],
      dateTime: [],
      dateType: "yesterDay",
      tableData: [],
      // 会议对象
      sessionsDetail: {},
      // 跟进事项节点
      entryBO: null,
      pageType: {
        pageNum: 1,
        pageSize: 10
      },
      total: undefined,
      dialogUploadVisible: false,
      itemDialogVisible: false,
      allWidth: 0
    };
  },
  async mounted() {
    this.initParams()
    getUserList().then(res=>{
      this.userList = res.data
    })
    this.user =  await getSystemUserInfo(this.$store.state.user.userId)
    this.getSessionList();
  },
  methods: {
    // 在关闭dialog前
    beforeClose(done){
      this.entryBO = null
      done()
    },
    // 删除事项
    deleteEntry(row) {
      const _this = this
      this.$confirm('此操作永久删除会议事项是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           deleteSessionEntry(row.id).then(res=>{
            this.$message({
              type: 'success',
              message: '删除成功!'
           })
           _this.viewDetail(_this.sessionsDetail)
           _this.entryBO = null
           _this.itemDialogVisible = false
          })
      })
    },
    // 修改事项
    modityEntryItem(row) {
      this.entryBO = row
    },
    // 切换到延期tab
    delayTab (row) {
      this.entryBO = {...row, _fulfillmentDate: row.fulfillmentDate, fulfillmentDate: null, yq:true}
    },
    // 更新会议事项状态 
    updateSessionsEntryMethod(row, status) {
      if (status == '2' && row.fulfillmentDate == null) {
        this.$message.error("延期时间不为空")
        return
      }
      updateSessionsEntry({
        ...row,
        status: status == null ? row.status : status,
        fulfillmentDate: row.fulfillmentDate
      }).then(res=>{
        // 刷新
        this.viewDetail(this.sessionsDetail)
        this.$message.success("操作成功")
        this.entryBO = null
      })
    },
    // 判断是否是管理员
    isAdmin() {
      return this.user.userId == this.sessionsDetail.createBy
    },
    // 查看
    viewDetail(row) {
      // 获取详情
      sessionsMinutesById(row.id).then(res=>{
        this.itemDialogVisible = true
        this.sessionsDetail = res.data

        // 对数据进行过滤
        if (this.isAdmin()) {
          // 管理员不需要过滤数据
          return
        }
        const userId = this.$store.state.user.userId
        this.sessionsDetail.entryBOList = this.sessionsDetail.entryBOList.filter(item=>{
          return item.userId == userId
        })

        if (this.sessionsDetail.entryBOList ==null || this.sessionsDetail.entryBOList.length === 0) {
          this.$message({
          message: '该会议暂无您需要跟进的事项',
          type: 'info',
          customClass: 'mzindex'
          })
        }
      })
    },
    // pdf浏览
    preview(row) {
      sessionsMinutesById(row.id).then(res=>{
        let sessionsFile = res.data.sessionsFile
        if (!sessionsFile.endsWith('.pdf')){
          this.$message.error("仅支持PDF浏览")
          return
        }
        window.open('/api/jz/file/download/pt-eiiplat/'+ sessionsFile)
      })
    },
    // 下载
    download(row) {
      sessionsMinutesById(row.id).then(res=>{
        let sessionsFile = res.data.sessionsFile
        getDownloadBlob(sessionsFile).then(res2=>{
          const blob = new Blob([res2.data]);
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download",  res.data.name + `.` + sessionsFile.split(".")[1]);
          document.body.appendChild(link);
          link.click();
          setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url); 
          }, 0);
        })
        
      })
    },
    // 添加会议纪要
    add () {
      if (!this.formUpload.name) {
        this.$message.error("请输入会议名称")
        return
      }

      if (!this.formUpload.sessionsFile) {
        this.$message.error("请上传会议文件")
        return
      }

      let entryListParam= []
      let isOk = true
      this.formUpload.entryList.forEach(entryItem=>{
        entryItem.personList.forEach((person)=>{
          if (!entryItem.entryName) {
            isOk = false
            return;
          }
          if (person.userIds == null || person.userIds.length == 0 || person.date == null) {
            isOk = false
            return
          }
          person.userIds.forEach(userId=>{
            entryListParam.push({
              entryName:entryItem.entryName,
              userId: userId,
              fulfillmentDate: person.date
            })
          })
        })
      })

      if (!isOk) {
        this.$message.error("请填写事项、跟进人、截止日期")
        return
      }

      let param = {
        name: this.formUpload.name,
        sessionsFile: this.formUpload.sessionsFile,
        entryList: entryListParam
      }

      // 保存
      addSessionsMinutes(param).then(res=>{
        this.$message.success("保存成功")
        this.dialogUploadVisible = false
        this.getSessionList()
      })

    },
    onSuccess (data,file,fileList) {
      if(data.code !=0) {
        return
      }
      this.formUpload.sessionsFile = data.file.uuid
      this.$message.success('上传成功');
    },
    onError (){
      this.$message.error('文件上传失败');
    },
    handleExceed(){
      this.$message.error('最多支持上传1个文件');
    },
    beforeUpload(file) {
    console.log(file.type)
      const ok = file.type.includes("word") || file.type.includes("pdf") || file.type.includes("xls") ||  file.type.includes("sheet")
      if (ok) {
        return true
      }
      this.$message.error("仅仅支持扩展名：.doc .pdf .xlsx");
      return false
    },
    searchData() {
      this.getSessionList();
    },
    async getSessionList() {
      this.form.beginTime = this.dateTime[0];
      this.form.endTime = this.dateTime[1];
      const { code, rows, total } = await sessionsMinutesList({
        name: this.form.name,
        'params[beginTime]': this.dateTime[0],
        'params[endTime]': this.dateTime[1],
        ...this.pageType
      });
      if (code != 0) return;
      this.tableData = rows;
      this.total = total;
    },
    checkPage(val) {
      this.pageType.pageNum = val;
      this.getSessionList();
    },
    exportData() {
      expUserList(this.form).then(res => {
        const blob = new Blob([res.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("id", "pdfID");
        link.setAttribute("download", `数据统计.xls`);
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url); 
        }, 0);
      });
    },
    addThings() {
      this.formUpload.entryList.push({
        entryName:'',
        personList: [
          {
            userId:'',
            date:''
          }
        ]
      })
    },
    addPerson(index) {
      this.formUpload.entryList[index].personList.push( {
                userId:'',
                date:''
              })
    },
    // 重置
    reset() {
      this.initParams()
      this.getSessionList();
    },
    initParams() {
      this.dateTime =  [
          moment()
            .subtract(6, "days")
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss"),
          moment()
            .subtract(0, "days")
            .endOf("day")
            .format("YYYY-MM-DD HH:mm:ss")
        ]
        this.form = {}
        this. pageType = {
          pageNum: 1,
          pageSize: 10
        }
    }
  }
};
</script>

<style lang="scss" scoped></style>

<style>
/* 关于Vue + element 中 message提示被dialog的遮罩层挡住问题 */
.mzindex {
    z-index: 9999 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/MeetingMinute/HomePage.vue